import Header from '@/pages/home/components/Header';
import HeroSection from '@/pages/home/components/HeroSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import CardsSection from '@/pages/home/components/CardsSection';
import ContactSection from '@/pages/home/components/ContactSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import MediaSection from '@/pages/home/components/MediaSection';
import IndexSection from '@/pages/home/components/IndexSection';
import RankingSection from '@/pages/home/components/RankingSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import AppSection from '@/pages/home/components/AppSection';
import FAQSection from '@/pages/home/components/FAQSection';
import AboutSection from '@/pages/home/components/AboutSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CommentsSection />
        <TopicsSection />
        <CardsSection />
        <ContactSection />
        <CarouselSection />
        <MediaSection />
        <IndexSection />
        <RankingSection />
        <FeaturesSection />
        <AppSection />
        <FAQSection />
        <AboutSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}